import { render, staticRenderFns } from "./p01.vue?vue&type=template&id=5fc18473&scoped=true&"
import script from "./p01.vue?vue&type=script&lang=js&"
export * from "./p01.vue?vue&type=script&lang=js&"
import style0 from "./p01.vue?vue&type=style&index=0&id=5fc18473&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc18473",
  null
  
)

export default component.exports